// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1rJb5","header":"PatientBlock_header__3xuTV","label":"PatientBlock_label__1uiQy","option":"PatientBlock_option__1jVf_"};